import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useChangePlayerFavorites = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.IChangePlayerFavoritesRequestData): Promise<Types.IChangePlayerFavoritesResponseData> => {
            const { data } = await send<Types.IChangePlayerFavoritesRequestData, Types.IChangePlayerFavoritesResponseData>({
                ID: 31106,
                responses: [31107, 31108],
                description: 'Change player favorites',
                errorLevel: 1,
                ...request
            });

            return data;
        }, [send]);
};
